import React from 'react'
import { useNavigate } from 'react-router-dom'
import logo from '../../assets/images/logo-new.svg'
import BurguerButton from './BurguerButton'

export default function Burguer(): React.ReactElement {
    const navigate = useNavigate()

    return (
        <div className="section-burguer">
            <img src={logo} alt="Logo CNA construtora" className="logo" onClick={() => navigate('/')} />
            <div className="burguer">
                <BurguerButton />
            </div>
        </div>
    )
}
